
<app-breadcrumb [title]="'Vehículos Inactivos'" [items]="['Vehiculos']" [active_item]="'Inactivos'"></app-breadcrumb>
<div class="container-fluid">
<div class="card">
   <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-ui-block me-2"></i>
      <h5 class="mb-0"><strong>LISTADO DE VEHÍCULOS INACTIVOS</strong></h5>
    </div>

  <div class="card-body custom-datatable noscroll">
    <div class="row mb-12">
      <div class="col-sm-12 col-md-3 ms-auto"> 
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Buscar....."
            [(ngModel)]="searchText"
            (input)="filterData()"
          />
          <span class="input-group-text">
            <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
          </span>
        </div>
      </div>
    </div>
    
    
    <div class="custom-datatable table-responsive mt-4">
      <table class="table table-hover table-bordered" id="tblInactivos">
          <thead class="bg-primary">
          <tr>
            <th class="text-center"  style="cursor: pointer;"><strong>PLACA</strong></th>
            <th class="text-center"  style="cursor: pointer;"><strong>INT.</strong></th>
            <th class="text-center"  style="cursor: pointer;"><strong>MARCA</strong></th>
            <th class="text-center"  style="cursor: pointer;"><strong>MODELO</strong></th>
            <th class="text-center"  style="cursor: pointer;"><strong>CLASE</strong></th>
            <th class="text-center"  style="cursor: pointer;"><strong>CC PROPIETARIO</strong></th>
            <th class="text-center"  style="cursor: pointer;"><strong>PROPIETARIO</strong></th>
            
            <th class="text-center" ><strong>RELACIÓN</strong></th>
            <th class="text-center" ><strong>TAR. OPERACIÓN</strong></th>
            <th class="text-center px-3" ><strong>SOAT</strong></th>
            <th class="text-center" style="width: 150px;"><strong>CDA</strong></th>
            <th class="text-center" ><strong>BIMESTRAL</strong></th>
            <th class="text-center" ><strong>RCC</strong></th>
            <th class="text-center" ><strong>RCE</strong></th>
            <th class="text-center" ><strong>OPCIONES</strong></th>

          </tr>
        </thead>

        <tbody>
           <tr *ngFor="
              let vehicle of filteredTableItems
                | paginate : { itemsPerPage: pageSize1, currentPage: page1 };
              let i = index
            ">
            <td class="text-center">{{ vehicle.placa }}</td>
            <td class="text-center">{{ vehicle.interno }}</td>
            <td class="text-center">{{ vehicle.marcas?.marca}}</td>
            <td class="text-center">{{ vehicle.modelo }}</td>
            <td class="text-center">{{ vehicle.tipoVehiculo?.tipos }}</td>
            <td class="text-center">{{ vehicle.Idpropietario }}</td>
            <td class="text-uppercase text-justify">
              {{ vehicle.propietario?.primernombre }} 
              {{ vehicle.propietario?.segundonombre }}
              {{ vehicle.propietario?.papellidos }}
              {{ vehicle.propietario?.seapellidos }}</td>             
            
            <td class="text-center">{{ vehicle.tipoRelacion?.relacion  }}</td>
            <td class="text-center">
              <span class="badge" [ngClass]="getEstadoColor(vehicle.tarjetasOperaciones?.[0]?.estadoCalculado?.estado)">
                {{ vehicle.tarjetasOperaciones?.[0]?.fecha_vencimiento ? (vehicle.tarjetasOperaciones?.[0]?.fecha_vencimiento | date:'dd-MM-yyyy') : 'Sin fecha' }}
              </span>
            </td>
            <td class="text-center">
              <span class="badge" [ngClass]="getEstadoColor(vehicle.historialSoat?.[0]?.estadoCalculado?.estado)">
                {{ vehicle.historialSoat?.[0]?.vencimiento_soat ? (vehicle.historialSoat?.[0]?.vencimiento_soat | date:'dd/MM/yyyy') : 'Sin fecha' }}
              </span>
            </td>
            <td class="text-center">
              <span class="badge" [ngClass]="getEstadoColor(vehicle.historialCda?.[0]?.estadoCalculado?.estado)">
                {{ vehicle.historialCda?.[0]?.vcda ? (vehicle.historialCda?.[0]?.vcda | date:'dd/MM/yyyy') : 'Sin fecha' }}
              </span>
            </td>
            <td class="text-center">
              <span class="badge" [ngClass]="getEstadoColor(vehicle.historialBimestral?.[0]?.estadoCalculado?.estado)">
                {{ vehicle.historialBimestral?.[0]?.proxima_revision ? (vehicle.historialBimestral?.[0]?.proxima_revision | date:'dd/MM/yyyy') : 'Sin fecha' }}
              </span>
            </td>
            <td class="text-center">
              <span class="badge" [ngClass]="getEstadoColor(vehicle.historialContractual?.[0]?.estadoCalculado?.estado)">
                {{ vehicle.historialContractual?.[0]?.fecha_vencimientoRCC ? (vehicle.historialContractual?.[0]?.fecha_vencimientoRCC | date:'dd/MM/yyyy') : 'Sin fecha' }}
              </span>
            </td>
            <td class="text-center">
              <span class="badge" [ngClass]="getEstadoColor(vehicle.historialExtraContractual?.[0]?.estadoCalculado?.estado)">
                {{ vehicle.historialExtraContractual?.[0]?.fecha_vencimientoRCE ? (vehicle.historialExtraContractual?.[0]?.fecha_vencimientoRCE | date:'dd/MM/yyyy') : 'Sin fecha' }}
              </span>
            </td>
            
            <td class="text-center align-middle">
              <div class="action text-center">
              <ul class="list-inline d-flex justify-content-center gap-3">
                <li class="">
                      <a href="javascript:void(0)"><i class="icon-check-box" (click)="avisoActivarPersona(vehicle.placa)" ngbTooltip="Activar Vehículos"></i></a>
                </li>
              </ul>
              </div>
            </td>

          </tr>
        </tbody>
      </table>


    </div>
    <div class="d-flex justify-content-between align-items-center mt-4">
      <!-- Selector de registros por página alineado a la izquierda -->
      <div class="d-flex align-items-center col-sm-12 ">
        <label for="pageSize1" class="me-2">Mostrar:</label>
        <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
          <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
        </select>
        <span class="ms-2">registros por página</span>
      </div>
    
        <!-- Mostrar cantidad total de registros centrado -->       
      <div class="mx-auto text-center">
        <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ vehicles.length || 0 }}</b></span>
      </div>
       

      <!-- Paginador alineado a la derecha -->
      <div class="text-end paginador-personalizado">
        <pagination-controls 
          (pageChange)="page1 = $event" 
          [maxSize]="5"
          
          [directionLinks]="true"
          [autoHide]="true"
          previousLabel="Anterior" 
          nextLabel="Siguiente">
        </pagination-controls>
      </div>
    </div>
    <div class="card-body">
      <div class="btn-showcase text-center">
        <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
          (click)="exportarExcel('tblInactivos', 'Listado_Inactivos')">
          <i class="icofont icofont-file-excel"></i> EXCEL
        </button>

        <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF" (click)="
            exportToPDF(
              'tblInactivos',
              'Listado_Inactivos',
              'Listado de Inactivos'
            )
          ">
          <i class="icofont icofont-file-pdf"></i> PDF
        </button>
      </div>
    </div>
  </div>
</div>

</div>












  